export default __webpack_public_path__ + "static/media/connect-background-pattern.64f437e6.svg";